<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">BSIMS</h6>
            </b-col>
          </b-row>
        </template>


        <!-- Table Search -->
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Container</label>
          <div class="col-sm-4 mb-3">
            <b-form-input
                placeholder="Container"
                v-model="searchForm.container"
                @keydown.enter="pagination.current=1;$refs.table.refresh()"
            ></b-form-input>
          </div>
          <label class="col-sm-2 col-form-label">Consignee</label>
          <div class="col-sm-4 mb-3">
            <b-form-input
                placeholder="Consignee"
                v-model="searchForm.consignee"
                @keydown.enter="pagination.current=1;$refs.table.refresh()"
            ></b-form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Date</label>
          <div class="col-sm-6 mb-3">
            <b-row>
              <b-col>
                <b-form-datepicker
                    id="startDate"
                    v-model="searchForm.startDate"
                    :max="searchForm.endDate"
                    locale="en-US"
                    label-no-date-selected="Start Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="endDate"
                    v-model="searchForm.endDate"
                    locale="en-US"
                    :min="searchForm.startDate"
                    label-no-date-selected="End Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
            </b-row>
          </div>
          <b-col>
            <button type="button" class="btn btn-info btn-block" @click="pagination.current=1;$refs.table.refresh()">
              <i class="fa fa-search"></i> Search
            </button>
          </b-col>
        </div>
        <!--  TABLE  -->
        <b-table :per-page="pagination.per_page"
                 :current-page="pagination.current"
                 ref="table"
                 id="table"
                 :items="loadPage"
                 :fields="columns"
                 :busy.sync="isLoading"
                 striped
                 borderless
                 outlined
                 hover
                 show-empty
                 empty-text="No records found..."
                 stacked="sm"
                 class="mb-3"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner label="Loading..." type="grow"></b-spinner>
            </div>
          </template>
          <!-- full detail on click -->
          <template #cell(container)="data">
            {{ data.item.no_cont }}
            <v-span>&nbsp;
              <b-badge variant="info">{{ data.item.no_voy_flight }}</b-badge>
            </v-span>
            <v-span>&nbsp;
              <b-badge v-if="data.item.tp_cont==='Isi'" variant="primary">&nbsp;{{ data.item.tp_cont }}&nbsp;</b-badge>
              <b-badge v-if="data.item.tp_cont==='Kosong'" variant="secondary">&nbsp;{{ data.item.tp_cont }}&nbsp;</b-badge>
            </v-span>
            <v-span>&nbsp;
              <b-badge v-if="data.item.kd_transaksi==1" variant="info">&nbsp;{{ data.item.kd_transaksi | direction_text }}&nbsp;</b-badge>
              <b-badge v-if="data.item.kd_transaksi==2" variant="danger">&nbsp;{{ data.item.kd_transaksi | direction_text }}&nbsp;</b-badge>
              <b-badge v-if="data.item.kd_transaksi==0" variant="light">&nbsp;{{ data.item.kd_transaksi | direction_text }}&nbsp;</b-badge>
            </v-span>
          </template>

          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                    md="6"
                    class="mb-1"
                    v-if="row.item.event_id>0"
                >
                  <dl>
                    <dt>GATE OUT</dt>
                    <dd><b>&nbsp;&nbsp;No.Polisi:</b> {{ row.item.lic_plate }}</dd>
                    <dd><b>&nbsp;&nbsp;Trucking:</b> {{ row.item.company_name }}</dd>
                    <dd><b>&nbsp;&nbsp;Jalur/Jam:</b> {{ row.item.lane }} / {{ row.item.evt_time | clean_timestamp }}</dd>
                    <dd><b>&nbsp;&nbsp;BSIMS post:</b> {{ row.item.bsims_posted }}</dd>
                  </dl>
                </b-col>
                <b-col
                    md="6"
                    class="mb-1"
                >
                  <dl>
                    <v-span v-if="row.item.tp_cont!=='Kosong'">
                      <dt>Dokumen</dt>
                      <dd><b>&nbsp;&nbsp;Pabean:</b> {{ row.item.sppb_no }}</dd>
                      <dd><b>&nbsp;&nbsp;SP2:</b> {{ row.item.spj_no }}</dd>
                      <dd><b>&nbsp;&nbsp;DO:</b> {{ row.item.do_no }}</dd>
                      <dd><b>&nbsp;&nbsp;AWB/BL:</b> {{ row.item.no_bl_awb }}</dd>
                    </v-span>
                    <dt>Container Info</dt>
                    <dd>
                      <b>&nbsp;&nbsp;Ukuran &amp; Jenis:</b>
                      <v-span>
                        {{ row.item.uk_cont }}/{{ row.item.jns_cont }}/{{ row.item.type_cont }}
                      </v-span>
                    </dd>
                  </dl>
                </b-col>
              </b-row>
              <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
              >
                Hide Details
              </b-button>
            </b-card>
          </template>
<!--
          <template #cell(status)="data">
            <b-badge :variant="status[0][data.value]">
              {{ status[1][data.value] }}
            </b-badge>
          </template>
-->
          <template #cell(actions)="data">
            <b-button-group size="sm">
              <b-button variant="primary" @click="data.toggleDetails">Details</b-button>
              <b-button
                  v-if="can('superadmin')"
                  variant="danger"
                  @click="deleteConfirmation(data.item)"
              >Delete</b-button>
            </b-button-group>
          </template>
        </b-table>
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>
    <b-modal header-class="bg-danger text-white" id="delete">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon> Delete {{ selected.container }} - {{ selected.no_voy_flight }}
       </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">This destructive action is not recoverable! </h4>
      <h4 class="text-center">Are you sure to delete document {{ selected.no_voy_flight }} record?</h4>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="deleteRecord(selected)">
          Yes, Delete it!
        </b-button>
        <b-button size="sm" variant="secondary" @click="hide('forget')">
          Forget it
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import {delBSIMSdoc, listBSIMSdoc} from "@/services/bsims";
import SimplePagination from "@/components/SimplePagination";
import {
  BFormDatepicker,
  BIcon, BIconExclamationTriangleFill,
  BIconPlusCircleFill, BSpinner,
} from "bootstrap-vue";

export default {
  name: "BSIMS",
  components: {
    SimplePagination,
    BFormDatepicker,
    BIcon,
    // eslint-disable-next-line vue/no-unused-components
    BIconExclamationTriangleFill, BIconPlusCircleFill,
    BSpinner,
  },
  data: () => ({
    isLoading: false,
    columns: [
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'status',
        label: 'STATUS',
        formatter: x => (x == 0 ?  'NEW' : ( x == 1 ? 'GTO' : '---' )),
      },
      {
        key: 'consignee',
        label: 'CONSIGNEE',
      },
//      {
//        key: 'sppb_no',
//        label: 'No.SPPB',
//      },
      {
        key: 'sppb_date',
        label: 'Date',
        formatter: x => typeof x === 'string' ?  x.replace(/1970-01-01.*|\+.*/, '') : '-',
      },
//      {
//        key: 'spj_no',
//        label: 'SP2',
//      },
//      {
//        key: 'consignee',
//        label: 'Consignee',
//      },
      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    pagination: {
      current: 1,
      last_page: 15,
      total_items:0,
      per_page: 10,
      at_last_page: false,
    },
    options: {
      search: [
        {text: '', value: ''},
        {text: 'Dok Kepabean', value: 'sppb'},
        {text: 'Container', value: 'container'},
        {text: 'Consignee', value: 'consignee'},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
    },
    searchForm: {
      container: '',
      consignee: '',
      doc_date: '',
      startDate: '',
      endDate: '',
    },
    selected: '',
  }),
  methods: {
    async loadPage(ctx) {
      this.isLoading = true;
      this.pagination.at_last_page = false;
      this.pagination.total_item = 0;
      try {
        const {data: {data: {rows}}} = await listBSIMSdoc(this.searchParams(ctx));
        const items = Array.isArray(rows.bsims) ? rows.bsims : [rows.bsims];
        this.pagination.total_items = items.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        return items;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    searchParams(ctx) {
      const searchData = {
        // [this.searchForm.type]: `${this.searchForm.keywords}`,
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
      };
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc': 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      if (this.searchForm.startDate) {
        searchData['start_date'] = this.searchForm.startDate;
      }
      if (this.searchForm.endDate) {
        searchData['end_date'] = this.searchForm.endDate;
      }
      if (this.searchForm.container) {
        searchData['container'] = `%${this.searchForm.container}%`;
      }
      if (this.searchForm.consignee) {
        searchData['consignee'] = `%${this.searchForm.consignee}%`;
      }
      return searchData;
    },
    deleteConfirmation(item) {
      if (!this.can('superadmin')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Access Denied',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'danger',
        })
        return
      }
      this.selected = item;
      this.$bvModal.show('delete')
    },
    async deleteRecord(item) {
      if (!this.can('superadmin')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Access Denied',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'danger',
        })
        return
      }
      this.$bvModal.hide('delete')
      await delBSIMSdoc(item.id)
      this.$bvToast.toast(`Doc No. [${item.no_voy_flight}] delete successfully`, {
        title: 'Deleted!',
        autoHideDelay: 1500,
        appendToast: false,
        variant: 'success',
      })
      this.pagination.current=1;
      this.$refs.table.refresh()
    },
  }
}
</script>

<style scoped>

</style>
